import React from 'react';
import Employees from '../../../components/organization/EmployeePage/EmployeePage';

const EmployeesPage = () => {
    return (
            <Employees />
    );
};

export default EmployeesPage;